const docusignFormUrl = 'https://na2.docusign.net/Member/PowerFormSigning.aspx';

export class PolicyLinkConstructor {
    static createBankAccountLink(): string {
        const account='4f64a519-42ef-43b3-bb4e-7426ccf45a37';
        const powerFormId = 'e8076226-e0ca-40b6-990c-8f55d7226c3e';
        return `${docusignFormUrl}?PowerFormId=${powerFormId}&env=na2&acct=${account}&v=2`;
    }

    static createChangeBeneficiaryLink(ownerResidentialState: string): string {
        const powerFormId = ownerResidentialState === 'MA' ? '3b21eba1-1e93-4c54-807b-2d22956aefb1' : 'c10acc12-d620-4e93-a5f7-d3dbb6b804c3';
        return `${docusignFormUrl}?PowerFormId=${powerFormId}`;
    }

    static creatChangeOwnerLink(): string {
        const powerFormId = 'ac919c7b-b72d-4a43-91bc-5da115a07c89';
        return `${docusignFormUrl}?PowerFormId=${powerFormId}`;
    }

    static createMailingAddressLink(): string {
        const powerFormId = 'eac29832-526b-4998-88de-cee08c61abcb';
        return `${docusignFormUrl}?PowerFormId=${powerFormId}`;
    }

    static createChangeNameLink(): string {
        const powerFormId = '78fa75c7-e9f4-4320-ba3d-b3d7a15f6d83';
        return `${docusignFormUrl}?PowerFormId=${powerFormId}`;
    }

    static createChangeFaceAmountLink(): string {
        const powerFormId = '9407219b-db55-41c8-b6bd-106486158865';
        return `${docusignFormUrl}?PowerFormId=${powerFormId}`;
    }

    static createDuplicatePolicyCertificateLink(ownerNameEmailEncode: string): string {
        const powerFormId: string = '2627213c-8e4d-40db-b571-7516b159fb65';
        return `${docusignFormUrl}?PowerFormId=${powerFormId}&${ownerNameEmailEncode}`;
    }

    static createCancelViaDocusignLink(): string {
        const powerFormId = '97c78b79-2232-45ad-8beb-406dd0d1962a';
        return `${docusignFormUrl}?PowerFormId=${powerFormId}`;
    }
}